var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 12C10 10.88 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.12 10 12Z",
    fill: "var(--fill-0, #646464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 18C10 16.88 10.9 16 12 16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20C10.9 20 10 19.12 10 18Z",
    fill: "var(--fill-0, #646464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 6C10 4.88 10.9 4 12 4C13.1 4 14 4.9 14 6C14 7.1 13.1 8 12 8C10.9 8 10 7.12 10 6Z",
    fill: "var(--fill-0, #646464)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionMore);
export default __webpack_public_path__ + "static/media/OptionMore.d084811a0b817a07a189bdbe3fc4fcd5.svg";
export { ForwardRef as ReactComponent };